const EMAIL_REDIRECT_ENVS = new Set(['localhost', 'dev', 'qa']);

/**
 * Normalizes env values from .env files (handles case, whitespace, and quotes).
 */
export const normalizeEnvironment = (environment) =>
	String(environment || '')
		.trim()
		.replace(/^['"]|['"]$/g, '')
		.toLowerCase();

/**
 * Returns true when outgoing email recipients should be redirected.
 */
export const shouldRedirectEmailRecipients = (environment) =>
	EMAIL_REDIRECT_ENVS.has(normalizeEnvironment(environment));

/**
 * Applies environment recipient policy to an email payload.
 * In DEV/QA, `to` is replaced with the real logged-in user email.
 */
export const applyEmailRecipientPolicy = (
	payload = {},
	{ environment, actualUserEmail } = {}
) => {
	if (!shouldRedirectEmailRecipients(environment) || !actualUserEmail) {
		return payload;
	}

	return {
		...payload,
		to: actualUserEmail,
	};
};
